/**
 * The edits the Worker has not answered yet. One owner: the evaluation sends them, "unsaved" counts them, and the screen
 * lays them over the Worker's last answer (`list`, in order).
 */
import { useCallback, useMemo, useRef, useState } from 'react'
import type { BuilderEdit } from '@testfeed/shopify-contracts'

export function usePendingEdits() {
  const edits = useRef<BuilderEdit[]>([])
  const [list, setList] = useState<BuilderEdit[]>([])
  const read = useCallback(() => edits.current, [])
  const set = useCallback((next: BuilderEdit[]) => {
    edits.current = next
    setList(next)
  }, [])
  return useMemo(() => ({ read, set, list }), [read, set, list])
}
export type PendingEdits = ReturnType<typeof usePendingEdits>
